// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
  It applies to page with side bar.
  Example: systemParams -> systemParams.component.scss
*/
/*
  It applies to the title (header) of page content body.
*/
/*
  It describes common behavior on mouse hover.
*/
/*
  It describes light shadow for any page block.
*/
/*
  It applies to entity block like project, facility which has own title, edit button and body.
*/
/*
  It applies together with entity-card mixin, which has been described above
*/
/*
  It applies together with 'entity-card' mixin, which has been described above.
*/
/*
  It applies together with 'entity-card' mixin, which has been described above.
*/
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.facilities-list-container {
  gap: 5px;
}

.facility-box {
  border: 1px solid #c8c8c8;
  padding: 10px 20px;
  width: 100%;
}
.facility-box .facility-edit {
  display: flex;
  align-items: center;
  flex: 0 0;
}
.facility-box .facility-details {
  flex: 1 0;
}
.facility-box h3 {
  font-weight: normal;
  font-size: 16px;
  font-family: GothamNarrowBook, sans-serif;
  color: #0b2d71;
  text-align: left;
  margin: 0;
}
.facility-box span {
  font-weight: normal;
  font-size: 16px;
  font-family: GothamNarrowBook, sans-serif;
  text-align: left;
  margin: 0;
}

.container-horizontal {
  display: flex;
  gap: 10px;
}

.container-vertical {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  overflow: auto;
}

.facility-info {
  margin: 10px 0px;
  width: 100%;
}

.actions {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  margin-top: auto;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
